/**
 * @module editablefield/editablefield
 */

import { Plugin } from 'ckeditor5/src/core';
import FootnoteEditing from './footnoteediting';
import FootnoteUI from './footnoteui';
import '../theme/footnote.pcss';

/**
 * The Footnote plugin.
 *
 * It loads the {@link module:footnote/footnoteediting~FootnoteEditing FootnoteEditing feature}
 * and the {@link module:footnote/footnoteui~FootnoteUI FootnoteUI feature}
 *
 * @extends {Plugin}
 */
export default class Footnote extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'Footnote';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ FootnoteEditing, FootnoteUI ];
	}
}
